import { groupSetups } from "./groups";

export const setupConfigs = [
  ...groupSetups
];